import type { OrgFormValues } from "../schemas/orgViewSchemas";

export const UNSAVABLE_RANKING_MESSAGE =
  "Set a tier (or mark as Ranked) to save the comment, status or display order.";

export function findUnsavableRankingEdits(
  rankings: OrgFormValues["rankings"] | undefined,
): string[] {
  return Object.entries(rankings ?? {})
    .filter(([, r]) => {
      if (r.rankingId || r.ranked || r.tier !== null) return false;
      return (r.comment ?? "").trim() !== "" || r.status !== "draft" || r.displayOrder !== 0;
    })
    .map(([tableId]) => tableId);
}
